export const Constants = {
  Button: 'button',
  DateTime: 'dateTime',
  Date: 'date',
  UploadFile: 'Upload file',
  DragAndDrop: 'Drag and drop your file here',
  OnlyCsv: '(only .csv)',
  DownloadTemplate: 'Download Template',
  UploadTemplate: 'Upload Template',
  UploadProducts: 'Upload Products',
  Edit: 'edit',
  Single: 'single',
  ViewDataTable: 'View Data Table',
  Error: 'error',
  Warning: 'warning',
  Validated: 'validated',
  Info: 'info',
  CSV: '.csv',
  Uploading: 'uploading',
  Complete: 'complete',
  CategoryProducts: 'categoryProducts',
  UploadedProducts: 'uploadedProducts',
  UploadStoresFile: 'Upload stores file',
  UploadError: 'Upload Error',
  CorruptedFile: 'Corrupted File',
  Cancel: 'Cancel',
  BulkModifiers: 'bulkPointModifiers',
  SalesTargetMedia: 'salesTargetMedia',
  Public: 'public',
  Private: 'private',
  Multipart: 'multipart',
  ProductList: 'product_list',
  uploadInventory: ' Upload inventory file. Download template',
  Any: 'Any',
  AddProducts: 'Add Product(s)',
  Select: 'Select',
  Xlsx: '.xlsx',
  bulkUploadPromotions: 'Bulk Upload Promotions',
  ErrorForFileUpload: 'Upload failed. Please try again.',
  uploadSuggestedSKUs: 'suggested_skus',
}

export const NUMBERS = {
  OneThousandTwentyFour: 1024,
  Fifty: 50,
  Hundred: 100,
  Zero: 0,
}

export const Size = {
  Medium: 'medium',
}

export const Variant = {
  Primary: 'primary',
  Secondary: 'secondary',
}

export const SELECTION_TYPE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
  LOADING: 'loading',
  NONE: 'none', //to be removed after fixes
}

export const LABELS = {
  ORDER_ITEM_OVERVIEW_PAGE: {
    SubItems: 'Sub Items',
    TransactionDetails: 'Transaction Details',
    DiscountInformation: 'Discount Information',
  },
}

export const API_VERSION = {
  V1: 'v1',
  V2: 'v2',
}

export const DATE_VALIDATION_TYPE = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  SCHEDULE: 'schedule',
}

export const STORE_SELECTOR_DROPDOWN = {
  ALL_STORES: 'all stores',
  STORE_WITHOUT_SIGN_IN: 'store without sign-in',
  EXCEL_UPLOAD: 'excel upload',
}

export const ACTION_DROPDOWN = {
  REMOVE_ALL_EXCEPT: 'remove all except',
  REMOVE_NUM_POINTS: 'remove # points',
  ADD_POINTS: 'add points',
}

export const SCHEDULE_DROPDOWN = {
  NOW: 'now',
  CUSTOM_SCHEDULE: 'custom schedule',
  END_OF_MONTH: 'end of month',
  END_OF_YEAR: 'end of year',
}

export const DATE_VALIDATION_MESSAGE = {
  END_DATE_HELPER_TEXT: 'Please select start date before selecting end date.',
  CAN_NOT_BE_GREATOR_THAN_END_DATE: "can't be greater than end date",
  MUST_BE_AFTER_START_DATE: 'must be after start date',
}

export const localCurrencyText = 'localCurrency' // Check the Key in Actvity Reviewi
export const FILE = {
  MAX_SIZE_IMAGE: 2,
  SIZE_BYTES: 1024 * 1024,
  MAX_MULTIPLE_IMAGES_SIZE: 25,
  ALLOWED_IMAGE_TYPES: ['image/png', 'image/jpeg', 'image/webp'],
}

export const DEFAULT_TABLE_PAGE_SIZE = 10

export const SUPPORTED_PRODUCT_MEDIA = ['.jpg', '.png', '.webp', '.gif', '.mp4']
